(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/marketplace-brand/assets/marketplace-brand-context.js') >= 0) return;  svs.modules.push('/components/marketplace/marketplace-brand/assets/marketplace-brand-context.js');
"use strict";


const _React = React,
  createContext = _React.createContext,
  useMemo = _React.useMemo;
const getProductDisplayName = svs.components.lbUtils.brandMapping.fn.getProductDisplayName;
const getRacingDisplayName = svs.utils.racing.getRacingDisplayName;
const MarketplaceBrandContext = createContext();
const MarketplaceBrandProvider = _ref => {
  let children = _ref.children;
  const value = useMemo(() => ({
    getBrandedDisplayName: getProductDisplayName,
    getRacingBrandedDisplayName: getRacingDisplayName
  }), []);
  return React.createElement(MarketplaceBrandContext.Provider, {
    value: value
  }, children);
};
setGlobal('svs.components.marketplace.marketplaceBrand.MarketplaceBrandContext', MarketplaceBrandContext);
setGlobal('svs.components.marketplace.marketplaceBrand.MarketplaceBrandProvider', MarketplaceBrandProvider);

 })(window);